// Live room — Follow Along (shared seed) types + constants.
//
// Locked spec 2026-05-10:
//  - KOL plays normally (own coin balance, manual SPIN, mode=solo phaser)
//  - Viewer in mode=watch phaser, sees KOL's reel animation
//  - Viewer can opt-in "Follow KOL" — backend then debits viewer's own coin
//    amount per KOL spin, rolls the SAME RNG seed → identical multiplier,
//    credit win = viewer's coin × KOL's multiplier
//  - Phaser stays unchanged. Spin animations driven via existing
//    `sss-replay-spin` postMessage.
//
// All player-facing numbers are "coins" — F2P, no real money. No "bet" /
// "wager" wording per feedback_no_bet_wording.md.
import { z } from 'zod';
export const LIVE_VIEWER_CAP = 5000;
/** Spin tick cadence for the KOL. NPC pilot uses this; real KOL is manual. */
export const LIVE_SPIN_INTERVAL_MS = 4500;
export const LIVE_FEVER_DURATION_MS = 4000;
export const LIVE_FEVER_VIEWER_REWARD = 500;
export const LIVE_HEAT_PER_SPIN = 3;
export const LIVE_HEAT_MAX = 100;
export const LiveGiftSku = z.enum([
    'heart',
    'bouquet',
    'sakura_storm',
    'rocket',
    'stars',
    'limited',
]);
export const LIVE_GIFT_COSTS = {
    heart: 10,
    bouquet: 50,
    sakura_storm: 200,
    rocket: 500,
    stars: 1000,
    limited: 2000,
};
export const LiveFollowRequest = z.object({
    follow: z.boolean(),
    coin_per_spin: z.number().int().min(1).max(100_000).optional(),
});
export const LiveGiftRequest = z.object({
    sku: LiveGiftSku,
});
export const LiveChatRequest = z.object({
    text: z.string().min(1).max(140),
});
//# sourceMappingURL=live.js.map